<template>
  <div class="bam-field" :class="type">
    <label v-if="label" class="label">{{ label }}</label>
    <slot />
    <p class="error-info">
      {{ message }}
    </p>
  </div>
</template>

<script>
export default {
  name: "BamField",
  props: {
    label: String,
    message: String,
    type: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      newMessage: this.message
    }
  },
  watch: {
    message(value) {
      this.newMessage = value
    }
  }
}
</script>

<style lang="scss" scoped>
//@import '../../styles/app/shared.scss';
@import '~assets/css/shared.scss';

.bam-field {
  height: remy(44);
}

.bam-field.is-danger ::v-deep .input-password input {
  border-color: $danger;
}

.bam-field.is-regular {
  margin-bottom: 1rem;
  max-height: remy(44);
}

.error-info {
  color: $danger;
  font-size: 12px;
  font-weight: 300;
  text-align: left;
}
</style>
